import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsmantri } from "../../../../data/projects/mantri/data";
import { projectspurvankara } from "../../../../data/projects/puravankara/data";

export const PurvankaraMeraki = () => {
  const {
    meraki: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectspurvankara;

  return (
    <>
      <Helmet>
        <title>Puravankara Purva Meraki, HSR Layout, Bengaluru – Luxury 3 & 4 BHK Apartments</title>

        <meta
          name="description"
          content="Discover Puravankara Purva Meraki in HSR Layout, Bengaluru – a premium residential project offering luxury 3 & 4 BHK apartments with world-class amenities, excellent connectivity, and modern living. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Puravankara Purva Meraki, Purva Meraki HSR Layout, Puravankara HSR Layout, Purva Meraki Bengaluru, luxury apartments HSR Layout, 3 BHK flats Bengaluru, 4 BHK apartments HSR Layout"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/puravankara-purva-meraki-hsr-layout-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
